<td
    class="member-cell d-flex"
    [ngbTooltip]="
        FLWinningPerson.isSubordinate == true ? fl_winning_team_tooltip : ''
    "
    tooltipClass="oa-widget-tooltip"
>
    <div class="member-name-icon-container">
        <div
            class="member-name-container row text-left d-flex justify-content-start align-items-center"
            (click)="getFlWinningPersonDR()"
            [ngClass]="{ indent: FLWinningPerson.isSubordinate == true }"
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-down"
                *ngIf="
                    FLWinningPerson.bottomRole !== true &&
                    FLWinningPerson.subOrdinates != null
                "
            ></cmps-icon>
            <cmps-icon
                class="cmps-cdk-fill-grey-300 cmps-cdk-text-center member-chevron"
                svgIcon="chevron-right"
                *ngIf="
                    FLWinningPerson.bottomRole !== true &&
                    FLWinningPerson.subOrdinates == null
                "
            ></cmps-icon>
            <div
                class="cmps-cdk-pl-2"
                *ngIf="FLWinningPerson.bottomRole === true"
            ></div>
            <span class="member-name">
                <span class="photo-name-sec">
                    <cmps-icon
                        class="user-icon"
                        svgIcon="account-circle"
                    ></cmps-icon>
                    <span
                        class="user-name-text"
                        [class.underline]="FLWinningPerson.bottomRole == true"
                        placement="right"
                        container="body"
                    >
                        {{ FLWinningPerson.userName | titlecase }}
                        <small *ngIf="FLWinningPerson.isSubordinate">
                            ({{ FLWinningPerson.role }})</small
                        >
                    </span>
                </span>
            </span>
            <span
                *ngIf="loadingFlWinningTeam"
                class="expand-icon d-block ml-2"
            >
                <cmps-wait-status></cmps-wait-status>
            </span>
        </div>
    </div>
</td>
<td [style.color]="FLWinningPerson.winningThresholdColour">
    <span
        class="cursor-default"
        placement="top"
        container="body"
    >
        {{
            FLWinningPerson.winning != null
                ? (FLWinningPerson.winning | number: '1.2-2')
                : '-'
        }}
    </span>
    <span
        class="score-percentage"
        *ngIf="FLWinningPerson.winning != null"
        >%</span
    >
</td>

<td>
    {{ FLWinningPerson.commitmentsAssessed | number: '1.0-0' }}
</td>

<td class="p-1">
    <div
        class="custom-row-bar"
        [cmpsTooltipTrigger]="winning_data_tooltip"
        tooltipClass="oa-widget-tooltip"
    >
        <div class="fraction-table-container funded-batch">
            <!-- ###################  ADD frontline winning grid Winning Percentage Data Bar  ################### -->
            <fraction-bar-winning
                class="fraction-bar"
                [winningNumber]="FLWinningPerson.winningNumber"
                [losingNumber]="FLWinningPerson.losingNumber"
                [neutralNumber]="FLWinningPerson.neutralNumber"
                [divisor]="FLWinningPerson.commitmentsAssessed"
                [maxWinning]="FLWinningPerson.maxWinning"
                [maxLosing]="FLWinningPerson.maxLosing"
                [maxNeutral]="FLWinningPerson.maxNeutral"
                [winningClass]="'green'"
                [neutralClass]="'yellow'"
                [losingClass]="'red'"
                [winningLabel]="FLWinningPerson.winning"
                [losingLabel]="FLWinningPerson?.losing"
                [neutralLabel]="FLWinningPerson.neutral"
            >
            </fraction-bar-winning>
        </div>
    </div>
</td>
<!-- ###################  ADD frontline winning grid Winning Data Popup  ################### -->
<ng-template #fl_winning_team_tooltip>
    <div
        class="custom-tooltip fl-wp-tooltip custom-user-tooltip no-min-width oatooltip"
    >
        <p>
            <strong
                ><b
                    >{{ _i18n._11144_SUPERGROUP_NAME___ | translate }}:</b
                ></strong
            >
            {{ FLWinningPerson.superGroup | translate }}
        </p>
        <p>
            <strong
                ><b
                    >{{ _i18n._11145_DAYS_IN_SUPERGROUP___ | translate }}:</b
                ></strong
            >
            {{ FLWinningPerson.daysInSuperGroup | translate }}
        </p>
        <p>
            <strong
                ><b>{{ _i18n._48_MANAGER___ | translate }}:</b></strong
            >
            {{ FLWinningPerson.manager | translate }}
        </p>
        <p>
            <strong
                ><b>{{ _i18n._59_ROLE___ | translate }}:</b></strong
            >
            {{ FLWinningPerson.role | translate }}
        </p>
    </div>
</ng-template>
<!-- ###################  ADD frontline winnin grid Team Popup  ################### -->
<ng-template #winning_data_tooltip>
    <div class="custom-tooltip fl-wp-tooltip no-min-width oatooltip">
        <p class="d-flex justify-content-between">
            <strong
                ><b>{{ _i18n._10085_WINNING___ | translate }}</b></strong
            >

            <span>
                {{ FLWinningPerson.winningNumber | translate }}
                ({{ FLWinningPerson.winning | translate }}%)
            </span>
        </p>
        <p class="d-flex justify-content-between">
            <strong
                ><b>{{ _i18n._10086_NEUTRAL___ | translate }}</b></strong
            >

            <span>
                {{ FLWinningPerson.neutralNumber | translate }}
                ({{ FLWinningPerson.neutral | translate }}%)
            </span>
        </p>
        <p class="d-flex justify-content-between">
            <strong
                ><b>{{ _i18n._10087_LOSING___ | translate }}</b></strong
            >

            <span>
                {{ FLWinningPerson.losingNumber | translate }}
                ({{ FLWinningPerson.losing | translate }}%)
            </span>
        </p>
        <p class="d-flex justify-content-between pt-2">
            <strong
                ><b>{{ _i18n._10088_TOTAL___ | translate }}</b></strong
            >

            <span>
                {{ FLWinningPerson.total | translate }}
            </span>
        </p>
    </div>
</ng-template>
